var map = {
	"./address_icon.png": 8983,
	"./company-bg.png": 7244,
	"./db-func-item0.png": 1736,
	"./db-func-item1.png": 3793,
	"./db-func-item2.png": 5062,
	"./db_content0.png": 428,
	"./db_content1.png": 4530,
	"./db_title_bg.png": 3063,
	"./djxinxilogo.png": 4412,
	"./djxinxilogo1.png": 6493,
	"./footer-addess-icon.png": 8404,
	"./footer-email-icon.png": 5421,
	"./footer-phone-icon.png": 6841,
	"./footer-postal-icon.png": 4529,
	"./harmful_function.png": 8367,
	"./harmful_title_bg.png": 7177,
	"./main-customer-bg.png": 885,
	"./main-product-bg0.png": 5123,
	"./main-product-bg1.png": 5075,
	"./main-product-bg2.png": 8591,
	"./main-product-bg3.png": 4725,
	"./main-technical-capability-bg.png": 9383,
	"./manage-func-item0.png": 7729,
	"./manage-func-item1.png": 8932,
	"./manage-func-item2.png": 283,
	"./manage-func-item3.png": 5365,
	"./manage-func-item4.png": 5057,
	"./manage-func-item5.png": 2851,
	"./news_img0.png": 577,
	"./news_img1.png": 6454,
	"./news_img2.png": 3444,
	"./news_img3.png": 9083,
	"./news_img4.png": 7346,
	"./news_img5.png": 7826,
	"./news_img6.png": 4386,
	"./news_img7.png": 2088,
	"./news_main_content_0.png": 8251,
	"./news_title_bg.png": 9751,
	"./product_module2.png": 2255,
	"./product_module3.png": 7750,
	"./product_module4.png": 3520,
	"./product_module5.png": 3030,
	"./product_module6.png": 3998,
	"./product_title_bg.png": 8023,
	"./solution-item-pic2.png": 3136,
	"./solution-item-pic3.png": 7055,
	"./solution-item-pic4.png": 6838,
	"./solution-item-pic5.png": 1645,
	"./solution-item-pic6.png": 4972,
	"./watch_alarm_0.png": 9161,
	"./watch_craft_0.png": 5269,
	"./watch_deal_0.png": 4032,
	"./watch_graph_0.png": 9538,
	"./watch_graph_1.png": 8160,
	"./watch_graph_2.png": 9282,
	"./watch_history_0.png": 596,
	"./watch_title_bg.png": 3981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;